import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, normalizeClass as _normalizeClass } from "vue";
import './menus.less';
import { ref, computed } from 'vue';
import MgMenuItem from './mg-menu-item.vue';
import MgMenuDividerItem from './mg-menu-divider-item.vue';
export default {
  __name: 'mg-menu',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    isActive: {
      type: Boolean,
      default: false
    },
    // 子菜单弹出对齐方式,right|left,默认右则
    popAlign: {
      type: String,
      default: 'right',
      validator: val => ['left', 'right'].includes(val)
    }
  },
  emits: ['click', 'item-click', 'mouseleave', 'mouseenter', 'hover', 'item-hover'],
  setup(__props, {
    emit: __emit
  }) {
    const menuRef = ref();
    const props = __props;
    const emit = __emit;
    const menuGroups = computed(() => {
      const groups = [];
      const prev = [];
      for (const item of props.items) {
        if (Array.isArray(item)) {
          prev.push(...item);
          prev.push('--');
          continue;
        }
        if (typeof item === 'string' && (item === '--' || item === '---')) {
          prev.push('--');
          continue;
        }
        if (typeof item === 'object') {
          const {
            title
          } = item;
          if (!title) continue;
          prev.push(item);
        }
      }
      if (prev.length) {
        groups.push(prev);
      }
      return groups;
    });
    const handleItemHover = ({
      item,
      isHover,
      $event
    }) => {
      $event.stopPropagation();
      emit('item-hover', {
        item,
        isHover,
        $event
      });
    };
    const handleItemClick = ({
      item,
      $event
    }) => {
      emit('item-click', {
        item,
        $event
      });
    };
    const handleMouseleave = e => {
      emit('mouseleave', {
        $event: e
      });
      emit('hover', {
        isHover: false,
        $event: e
      });
    };
    const handleMouseenter = e => {
      emit('mouseenter', {
        $event: e
      });
      emit('hover', {
        isHover: true,
        $event: e
      });
    };
    const handleClick = e => {
      emit('click', e);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['mg-menu-wrapper', {
          'is--active': __props.isActive
        }, {
          'pop-align-left': __props.popAlign === 'left',
          'pop-align-right': __props.popAlign === 'right'
        }]),
        onMouseleave: handleMouseleave,
        onMouseenter: handleMouseenter,
        onClick: handleClick,
        ref_key: "menuRef",
        ref: menuRef
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuGroups.value, (group, groupIdx) => {
        return _openBlock(), _createElementBlock("ul", {
          key: groupIdx,
          class: "mg-menu-links-wrapper"
        }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (item, itemIdx) => {
          return _renderSlot(_ctx.$slots, "render-item", {
            item: item,
            itemIndex: itemIdx
          }, () => [item === '--' || item.title === '--' ? (_openBlock(), _createBlock(MgMenuDividerItem, {
            key: 0
          })) : (_openBlock(), _createBlock(MgMenuItem, _mergeProps({
            key: `item_${groupIdx}_${itemIdx}`
          }, {
            ref_for: true
          }, item, {
            popAlign: __props.popAlign,
            onHover: opts => handleItemHover({
              item,
              ...opts
            }),
            onItemHover: handleItemHover,
            onItemClick: handleItemClick,
            onClick: e => handleItemClick({
              item,
              $event: e
            })
          }), null, 16, ["popAlign", "onHover", "onClick"]))]);
        }), 256))]);
      }), 128))], 34);
    };
  }
};